import React from "react";
import DemoTable from "../../../../components/table/demoTable";
import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";



const WorkflowPage = () => {
  const navigate = useNavigate();

  const workflows = [
    { name: "Lead Update", trigger: "User/Update", tasks: "Email send" },
   
  ];

  const columns = [
    { id: 'sno', label: 'S.No', minWidth: 10, align: 'center' },
    { id: "name", label: "Workflow Name", minWidth: 100, align: 'center' },
    { id: "trigger", label: "Trigger/Action", minWidth: 100, align: 'center' },
    { id: "tasks", label: "Tasks", minWidth: 100, align: 'center' },
    { id: "action", label: "Actions", minWidth: 100, actionType: [{ edit: true, delete: true }], align: 'center' }
  ];

  const transformSchemas = (schema) =>
    schema.map((item, index) => ({
      sno: index + 1,
      name: item.name,
      trigger: item.trigger,
      tasks: item.tasks,
    }));

  const modifiedRows = workflows ? transformSchemas(workflows) : [];

  const handleEdit = (row) => {
    console.log("Edit", row);
  };

  const handleDelete = (row) => {
    console.log("Delete", row);
  };

  const handleAddWorkflow = () => {
    navigate("/createApp/addWorkflow");
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 3 }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center" sx={{ mb: 2 }}>
        Workflow Management
      </Typography>

      <Button
        onClick={handleAddWorkflow}
        startIcon={<AddIcon />}
        sx={{ mb: 3, alignSelf: 'flex-end', fontWeight: 'bold', backgroundColor: 'success.main', color: 'white' }}
      >
        Add Workflow
      </Button>

      <DemoTable
        columns={columns}
        rows={modifiedRows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
      />
    </Box>
  );
};

export default WorkflowPage;
